module.exports = __webpack_public_path__ + "static/media/logo.025ec7bd.svg";